import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommunicationViewerComponent} from './components/communication-viewer/communication-viewer.component';
import {CommunicationEditorComponent} from './components/communication-editor/communication-editor.component';
import {
  CommunicationListEntryComponent
} from './components/communication-list-entry/communication-list-entry.component';
import {CommunicationDiffComponent} from './components/communication-diff/communication-diff.component';
import {CommunicationBuilderComponent} from './components/communication-builder/communication-builder.component';
import {CommunicationFilterComponent} from './components/communication-filter/communication-filter.component';
import {CommunicationListComponent} from './components/communication-list/communication-list.component';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';
import {CommunicationDisplayComponent} from './components/communication-display/communication-display.component';
import {VirtualScrollModule} from '../virtual-scroll/virtual-scroll.module';
import {FlagModule} from '../flag/flag.module';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {RippleModule} from 'primeng/ripple';
import {DialogModule} from 'primeng/dialog';
import {AuditModule} from '../audit/audit.module';
import {AppCommonModule} from "../app-common/app-common.module";
import {TooltipModule} from "primeng/tooltip";
import {AiAssistantModule} from "../ai-assistant/ai-assistant.module";


@NgModule({
  declarations: [
    CommunicationViewerComponent,
    CommunicationEditorComponent,
    CommunicationListEntryComponent,
    CommunicationDiffComponent,
    CommunicationBuilderComponent,
    CommunicationFilterComponent,
    CommunicationListComponent,
    CommunicationDisplayComponent
  ],
    imports: [
        CommonModule,
        LayoutLibraryModule,
        VirtualScrollModule,
        FlagModule,
        WidgetLibraryModule,
        RippleModule,
        DialogModule,
        AuditModule,
        AppCommonModule,
        TooltipModule,
        AiAssistantModule
    ],
  exports: [
    CommunicationViewerComponent,
    CommunicationFilterComponent,
    CommunicationListComponent,
    CommunicationListEntryComponent,
    CommunicationBuilderComponent,
    CommunicationDiffComponent,
    CommunicationDisplayComponent
  ]
})
export class CommunicationCommonModule { }
